import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

import { PageHeader } from "./shared";

export function ResponsibilitiesSection() {
  return (
    <>
      <PageHeader
        title="My responsibilities"
        subtitle="What the Super Admin owns, and what belongs to operating teams."
      />
      <div className="grid gap-4 p-4 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>I own these</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <Responsibility
              title="Approved field library"
              body="I decide which fields may appear on scholarship forms. Program managers can only use approved fields."
            />
            <Responsibility
              title="Workflows"
              body="I define approved workflows and reusable setup choices. Program managers use published workflows, but cannot edit review steps."
            />
            <Responsibility
              title="Platform standards"
              body="I keep finance, privacy, and review safety rules consistent across organizations."
            />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>I set up, they operate</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <Responsibility
              title="Organizations and users"
              body="I create organizations and staff access. PMs prepare scholarship setup; tenant admins confirm readiness and activate launch."
            />
            <Responsibility
              title="Application review"
              body="Reviewers, management, and finance teams decide on applications. I do not approve or reject students."
            />
            <Responsibility
              title="Payments"
              body="Finance reviewers own payment approval and disbursal readiness. I do not override finance."
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
}

function Responsibility({ title, body }: { title: string; body: string }) {
  return (
    <div className="rounded-lg border bg-gray-50 p-4">
      <div className="font-medium text-gray-950">{title}</div>
      <p className="mt-1 text-gray-600">{body}</p>
    </div>
  );
}
